export const PageContextForNews = Object.freeze({
  NEWS: 'news',
  MAIN: 'main'
});

export class NewsItem {
  constructor(data) {
    this.data = { ...data };
  }

  getDate() {
    return this.data.datetime;
  }
  getTitle() {
    return this.data.title;
  }
  getText() {
    return this.data.announce;
  }
  getLink() {
    return this.data.link;
  }
}



// WEBPACK FOOTER //
// ./src/shared/types/news.js